
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbAuthService, NB_AUTH_OPTIONS, NbAuthResult } from '@nebular/auth';



@Component({
  selector: 'nb-logout',
  templateUrl: './logout.component.html',
})
export class bitLogoutComponent implements OnInit {
  ngOnInit() {

  }

  redirectDelay: number = 0;
  strategy: string = '';

  constructor(protected service: NbAuthService,
              @Inject(NB_AUTH_OPTIONS) protected options = {},
              protected router: Router) {


    this.logout(this.strategy);
  }

  logout(strategy: string): void {

    this.service.logout(strategy).subscribe((result: NbAuthResult) => {

      const redirect = result.getRedirect();
      if (redirect) {
        setTimeout(() => {
          return this.router.navigateByUrl(redirect);
        }, this.redirectDelay);
      }
    });
  }

}